import MUISlider, { SliderProps } from '@mui/material/Slider';

interface Props extends SliderProps {
  width?: string;
}

const Slider = ({ width = '100%', ...props }: Props) => {
  return (
    <MUISlider
      aria-label="Always visible"
      min={0}
      step={1}
      valueLabelDisplay="off"
      marks={false}
      sx={{
        height: '3px',
        width,
        '& .MuiSlider-thumb': { width: '12px', height: '12px' },
      }}
      {...props}
    />
  );
};

export default Slider;
